// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Container-m_MVQzzdttiIji7dIoJSX1 {
    width: 25%;
    border: 1px solid #cecece;
    display: flex;
    flex-direction: column;
    background-color: var(--text-white);
    padding: 1.5rem;
    align-items: center;
    border-radius: 5px;
    box-shadow: 4.0px 8.0px 8.0px hsl(0deg 0% 0% / 0.38);
}

.Container-m_anBNkqbBSvDpNwinLU9J {
    margin-bottom: 1.5rem;
}

.Container-m_j8Y_IOElv_I3i1e0spZ4 {
    width: 27rem;
    margin-bottom: 2rem;
}

.Container-m_ILvPs95f2N0rGkux4YoW {
    width: 100%;
}

@media (max-width: 480px) {
    .Container-m_MVQzzdttiIji7dIoJSX1 {
        width: 75vw;
    }

    .Container-m_j8Y_IOElv_I3i1e0spZ4 {
        width: 16rem;
    }
}`, "",{"version":3,"sources":["webpack://./client/login/Container/Container.m.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".container {\n    width: 25%;\n    border: 1px solid #cecece;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--text-white);\n    padding: 1.5rem;\n    align-items: center;\n    border-radius: 5px;\n    box-shadow: 4.0px 8.0px 8.0px hsl(0deg 0% 0% / 0.38);\n}\n\n.title {\n    margin-bottom: 1.5rem;\n}\n\n.logo {\n    width: 27rem;\n    margin-bottom: 2rem;\n}\n\n.content {\n    width: 100%;\n}\n\n@media (max-width: 480px) {\n    .container {\n        width: 75vw;\n    }\n\n    .logo {\n        width: 16rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export var container = `Container-m_MVQzzdttiIji7dIoJSX1`;
export var title = `Container-m_anBNkqbBSvDpNwinLU9J`;
export var logo = `Container-m_j8Y_IOElv_I3i1e0spZ4`;
export var content = `Container-m_ILvPs95f2N0rGkux4YoW`;
export default ___CSS_LOADER_EXPORT___;
